import { render, staticRenderFns } from "./RequestDataForRegion.vue?vue&type=template&id=8feb588c&scoped=true"
import script from "./RequestDataForRegion.vue?vue&type=script&lang=js"
export * from "./RequestDataForRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8feb588c",
  null
  
)

export default component.exports